export default {
    data: () => ({
        translations: {
            name: {
                el: "Name",
                en: "Name",
                it: "Nome"
            },
            email: {
                el: "Email",
                en: "Email",
                it: "Email"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            save: {
                el: "Αποθηκευση",
                en: "Save",
                it: "Risparmiare"
            },
            saveAsNew: {
                el: "Αποθηκευση νέου",
                en: "Save as new",
                it: "Salva nuovo"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            uploadNewThumbnail: {
                el: "Φόρτωση νέας Mικρογραφίας",
                en: "Upload New Thumbnail",
                it: "Caricare una nuova Miniatura"
            },
            deleteEmailTheme: {
                el: "Διαγραφή προτύπου email",
                en: "Delete Email Theme",
                it: "Cancellare il modello di e-mail"
            },
            editEmailTheme: {
                el: "Επεξεργασία προτύπου email",
                en: "Edit Email Theme",
                it: "Modifica il modello di e-mail"
            },
            deleteConfirmationMessage: {
                el: "Σίγουρα θέλεις να διαγράψεις",
                en: "Are you sure you want to delete",
                it: "Siete sicuri di voler eliminare"
            },
            questionmark: {
                el: ";",
                en: "?",
                it: "?"
            },
            createNewEmailTheme: {
                el: "Δημιουργία νέoυ προτύπου email",
                en: "Create New Email Theme",
                it: "Creare un nuovo modello di e-mail"
            },
            rewardId:{
                el: "ID",
                en: "ID",
                it: "ID"
            },
            title: {
                el: "Τίτλος",
                en: "Title",
                it: "Titolo"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            thumbnail: {
                el: "Mικρογραφία",
                en: "Thumbnail",
                it: "Miniatura"
            },
            edit: {
                el: "Επεξεργασία",
                en: "Edit",
                it: "Modifica"
            },
         
        }
    })
};
